import { BlazeLogo } from 'components/MultiStepFlow/MultiStepPageLayout/BlazeLogo'
import { Brand, Calendar2, Lightning, LinkAngled, MoreDots } from 'blaze-ui/icons'
import { Button } from 'blaze-ui/Button'
import { copyTextToClipboard } from 'utils/articleUtils'
import { Heading } from 'blaze-ui/Heading/Heading'
import { Text } from 'blaze-ui/Text/Text'
import { useRootStore } from 'stores/RootStore'
import AutopilotStyles from 'screens/AutopilotRegistration/AutopilotRegistrationAndOnboarding.module.scss'
import cx from 'classnames'
import Styles from './LegacyMobileStop.module.scss'
import { ThreeDotMenuDrawer } from 'screens/VirtualMarketerOnboarding/ThreeDotMenuDrawer/ThreeDotMenuDrawer'

export const LegacyMobileStop = () => {
  const { drawersStore } = useRootStore()

  const handleCopyDesktopLink = () => {
    // eslint-disable-next-line no-restricted-properties
    copyTextToClipboard(window.location.href)
  }

  const openLogoutDrawer = () => {
    drawersStore.openDrawer(ThreeDotMenuDrawer)
  }

  return (
    <div className={cx(Styles.page, AutopilotStyles.cloudBackground)}>
      <div className={Styles.header}>
        <div className={Styles.logo}>
          <BlazeLogo width={80} height={22.3} />
        </div>
        <Button variant="ghost" onPress={openLogoutDrawer}>
          <MoreDots color="var(--dark-100)" size={24} />
        </Button>
      </div>
      <div className={Styles.root}>
        <Heading level={1}>Finish setting up Blaze on a desktop</Heading>
        <div className={Styles.content}>
          <Text>
            We sent you a link via email. On your computer, please go to <strong>app.blaze.ai</strong> to finish setup
            and view your content.
          </Text>
          <div className={Styles.infoRows}>
            <div className={Styles.infoRow}>
              <Brand size={24} color="var(--selected-fill)" />
              <Text>Personalize your content</Text>
            </div>
            <div className={Styles.infoRow}>
              <Lightning size={24} color="var(--selected-fill)" />
              <Text>Connect your accounts</Text>
            </div>
            <div className={Styles.infoRow}>
              <Calendar2 size={24} color="var(--selected-fill)" />
              <Text>Start autoposting</Text>
            </div>
          </div>
          <div className={Styles.cta}>
            <Button size="xl" frontIcon={LinkAngled} fullWidth onPress={handleCopyDesktopLink}>
              Copy Desktop Link
            </Button>
          </div>
        </div>
      </div>
      <div className={Styles.bottomDock}>
        <img
          src="https://res.cloudinary.com/almanac/image/upload/v1762362525/virtual_marketer_onboarding/onboarding-mobile-push-to-app-calendar_ajtkse.png"
          alt="Blaze Calendar on Desktop"
        />
      </div>
    </div>
  )
}
